// Generated from scripts/entrance.ts. Rebuild with pnpm scripts:build.
import { prefersReducedMotion } from '@theme/utilities';
/** The attribute that names the motion an element is playing; the stylesheet keys its animation on it. */
const MARKER = 'data-entrance';
/** The cards of a grid. A callout tile that chose no entrance asked for no motion and is left out. */
const CARDS = ".product-grid__item, [data-grid-tile]:not([data-animation='none']), .resource-list--grid .resource-list__item";
/** What stops a section from entering as a whole. */
const HOLDS_OWN_MOTION = '.product-grid__item, .resource-list--grid, sticky-add-to-cart';
/** The bottom part of the viewport, as a share of its height, in which a top edge counts as coming up from below. */
const ENTRY_ZONE = 0.2;
const kinds = new WeakMap();
/** Elements whose first report found them outside the viewport: only these can still play. */
const waiting = new WeakSet();
function play(element) {
    const kind = kinds.get(element);
    if (!kind || prefersReducedMotion())
        return;
    if (kind === 'section' && element.querySelector(HOLDS_OWN_MOTION))
        return;
    const finish = (event) => {
        // A card holds animations of its own (a price being recalculated); only the entrance ends the marker.
        if (event.target !== element)
            return;
        element.removeAttribute(MARKER);
        element.removeEventListener('animationend', finish);
        element.removeEventListener('animationcancel', finish);
    };
    element.addEventListener('animationend', finish);
    element.addEventListener('animationcancel', finish);
    element.setAttribute(MARKER, kind);
}
function cameInFromBelow(entry) {
    const bottom = entry.rootBounds?.bottom ?? window.innerHeight;
    const height = entry.rootBounds?.height ?? window.innerHeight;
    const { top } = entry.boundingClientRect;
    return top > bottom - height * ENTRY_ZONE;
}
function report(observer, entries) {
    for (const entry of entries) {
        const element = entry.target;
        if (!waiting.has(element)) {
            // The first report says where the element was when it was found.
            if (entry.isIntersecting)
                observer.unobserve(element);
            else
                waiting.add(element);
            continue;
        }
        if (!entry.isIntersecting)
            continue;
        observer.unobserve(element);
        waiting.delete(element);
        if (cameInFromBelow(entry))
            play(element);
    }
}
function register(observer, element, kind) {
    if (kinds.has(element))
        return;
    kinds.set(element, kind);
    observer.observe(element);
}
/** Registers the section `node` is, the cards it is and the cards it holds; `main` decides which nodes are sections. */
function registerWithin(observer, main, node) {
    if (node.parentElement === main && node.classList.contains('shopify-section'))
        register(observer, node, 'section');
    if (node.matches(CARDS))
        register(observer, node, 'card');
    for (const card of node.querySelectorAll(CARDS))
        register(observer, card, 'card');
}
function start() {
    const main = document.querySelector('main');
    if (!main || !('IntersectionObserver' in window))
        return;
    const observer = new IntersectionObserver((entries) => report(observer, entries));
    for (const child of main.children)
        registerWithin(observer, main, child);
    new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes)
                if (node instanceof Element)
                    registerWithin(observer, main, node);
        }
    }).observe(main, { childList: true, subtree: true });
}
start();
